import { IFeaturesSettings } from '@core/types'
import { ApiProperty } from '@nestjs/swagger'

export class FeaturesSettings implements IFeaturesSettings {
	@ApiProperty({ type: Boolean })
	reservation: boolean

	@ApiProperty({ type: Boolean })
	kitchen: boolean

	@ApiProperty({ type: Boolean })
	statistics: boolean

	@ApiProperty({ type: Boolean })
	whatsApp: boolean
}
